import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import { MentionGroupListContainer, Title } from "./MentionGroupList.styled";
import AddEditMentionGroup from "../AddEditMentionGroup";

import "./MentionGroupList.scss";

/**
 * Site List,
 * Path - /sites
 * @see See [Sites Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944008228/Company+view+page+-+Sites)
 * @component
 */
const MentionGroupList = (props) => {
  const { t, columnList, countries } = props;

  const [isAddGroupPopupVisible, setAddGroupPopupVisible] = useState(false);
  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewGroup = () => {
    setAddGroupPopupVisible(true);
  };
  const closeGroupCreationPopup = () => {
    setAddGroupPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <MentionGroupListContainer className="mentiongroup-list">
      <Title>{t("MENTION_GROUPS")}</Title>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        columnList={columnList}
        updateRefeshStatus={updateRefeshStatus}
        createNewGroup={createNewGroup}
        countries={countries}
      />
      {isAddGroupPopupVisible && (
        <AddEditMentionGroup
          title={t("MENTION_GROUP_NEW")}
          onClose={closeGroupCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </MentionGroupListContainer>
  );
};

MentionGroupList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

MentionGroupList.defaultProps = {
  columnList: [],
};

export default withTranslation()(MentionGroupList);
